import React, { useEffect, useState, useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

import SummaryCard from './SummaryCard';
import SummaryCardSkeleton from './SummaryCardSkeleton';
import { getDataReportAll } from '../../../../slices/thunks';
import config from '../../../../config';
import { useMantineTheme } from '@mantine/core';

const Summary = ({ code_siep }) => {
	const dispatch = useDispatch();
	const mantineTheme = useMantineTheme();
	const [dataInterval, setDataInterval] = useState('24h');

	// Access the slice state
	const { data, isLoading, isSuccess, isError } = useSelector(
		state => state.AllProvider || {}
	);

	// Chart configuration options
	const chartDataOptions = useMemo(
		() => ({
			'Oxígeno Disuelto': `["${mantineTheme.colors.blue[5]}" , "--vz-transparent"]`,
			'Saturación Oxígeno': `["${mantineTheme.colors.green[5]}" , "--vz-transparent"]`,
			Temperatura: `["${mantineTheme.colors.red[5]}" , "--vz-transparent"]`,
			Salinidad: `["${mantineTheme.colors.yellow[5]}" , "--vz-transparent"]`,
			Clorofila: `["${mantineTheme.colors.grape[5]}" , "--vz-transparent"]`,
			Turbidez: `["${mantineTheme.colors.orange[5]}" , "--vz-transparent"]`,
		}),
		[]
	);

	// Expected number of cards for skeleton
	const expectedCardsCount = Object.keys(chartDataOptions).length;

	// Process data with chart colors
	const updatedData = useMemo(() => {
		if (!data) return [];

		return data.map(item => ({
			...item,
			dataColors:
				chartDataOptions[item.title] ||
				'["--vz-secondary" , "--vz-transparent"]',
		}));
	}, [data, chartDataOptions]);

	useEffect(() => {
		if (!code_siep) return;

		const requestData = {
			username: config.user_providers.USER,
			password: config.user_providers.PASS,
			service: 'innovex',
			interval: dataInterval,
			siep: code_siep,
			variable: 'all',
		};

		dispatch(getDataReportAll(requestData));
	}, [dispatch, dataInterval, code_siep]);

	// Render skeleton loading state
	const renderSkeletonCards = () => (
		<Row className='g-3'>
			{Array.from({ length: expectedCardsCount }).map((_, index) => (
				<Col key={`skeleton-${index}`} xxl={2} lg={4} md={6} sm={6} xs={12}>
					<SummaryCardSkeleton />
				</Col>
			))}
		</Row>
	);

	if (isLoading) {
		return renderSkeletonCards();
	}

	return (
		<React.Fragment>
			<Row className='g-3'>
				{(updatedData || []).map((item, key) => (
					<Col key={key} xxl={2} lg={4} md={6} sm={6} xs={12}>
						<SummaryCard item={item} />
					</Col>
				))}
			</Row>
		</React.Fragment>
	);
};

export default Summary;
